import { render, staticRenderFns } from "./properties-block-column.vue?vue&type=template&id=2437f821&scoped=true"
import script from "./properties-block-column.vue?vue&type=script&lang=js"
export * from "./properties-block-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437f821",
  null
  
)

export default component.exports